<template>
  <div>
    <b-table
      :items="items"
      :fields="fields"
      class="table-bordered table-hover col-md-12"
      :busy="loading"
    >
      <template v-slot:table-busy>
        <vcl-table
          :speed="5"
          :animate="true"
          :columns="4"
        ></vcl-table>
      </template>
      <template v-slot:cell(stt)="row">
        <div class="d-flex justify-content-center w-6">
          <span v-text="row.item.stt"></span>
        </div>
      </template>
      <template v-slot:cell(name)="row">
        <div v-if="row.item.level == 1">
          <p class="ml-10">{{ row.item.name }}</p>
        </div>
        <div v-else-if="row.item.level == 2">
          <p class="ml-20">{{ row.item.name }}</p>
        </div>
        <div v-else-if="row.item.level == 3">
          <p class="ml-30">{{ row.item.name }}</p>
        </div>
        <div v-else-if="row.item.level == 4">
          <p class="ml-40">{{ row.item.name }}</p>
        </div>
        <div v-else-if="row.item.level == 5">
          <p class="ml-50">{{ row.item.name }}</p>
        </div>
        <div v-else-if="row.item.level == 0">
          <p>{{ row.item.name }}</p>
        </div>
      </template>

      <template v-slot:cell(code)="row">
        <div v-if="row.item.level == 1">
          <p class="ml-10">{{ row.item.code }}</p>
        </div>
        <div v-else-if="row.item.level == 2">
          <p class="ml-20">{{ row.item.code }}</p>
        </div>
        <div v-else-if="row.item.level == 3">
          <p class="ml-30">{{ row.item.code }}</p>
        </div>
        <div v-else-if="row.item.level == 4">
          <p class="ml-40">{{ row.item.code }}</p>
        </div>
        <div v-else-if="row.item.level == 5">
          <p class="ml-50">{{ row.item.name }}</p>
        </div>
        <div v-else-if="row.item.level == 0">
          <p>{{ row.item.code }}</p>
        </div>
      </template>
      <template v-slot:cell(status)="row">
        <i v-bind:class="{
            'fas fa-check text-success': row.item.status == 1,
            'fas fa-minus-circle text-danger': row.item.status != 1,
          }" />
      </template>
      <template v-slot:cell(type)="row">
        <span
          v-if="row.item.type === 1"
          v-text="row.item.typeName"
          class="label font-weight-bold label-lg label-light-success label-inline"
        ></span>
        <span
          v-else
          v-text="row.item.typeName"
          class="label font-weight-bold label-lg label-light-danger label-inline"
        ></span>
      </template>
      <template v-slot:cell(actions)="row">
        <div class="d-flex justify-content-center">
          <b-dropdown
            size="sm"
            id="dropdown-left"
            no-caret
            right
          >
            <template slot="button-content">
              <i
                style="font-size: 1rem; padding-right: 0px"
                class="flaticon2-settings"
              ></i>
            </template>
            <b-dropdown-item
              @click="$emit('edit', row.item)"
              v-if="checkViewOnly"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 10px"
                  class="flaticon2-box-1"
                ></i>
                &nbsp; Chi tiết
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              @click="$emit('edit', row.item)"
              v-if="!checkViewOnly"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 1rem"
                  class="flaticon2-pen"
                ></i>
                &nbsp; Chỉnh sửa
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              @click="$emit('add-child', row.item)"
              v-show="checkPermission('TRANSACTION_CATE_INSERT')"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 1rem; color: #1bc5bc !important"
                  class="fas fa-plus"
                ></i>
                &nbsp; Thêm danh mục con
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              @click="$emit('delete', row.item)"
              v-show="canDelete(row.item)"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 1rem; color: #d33"
                  class="flaticon2-rubbish-bin-delete-button"
                ></i>
                &nbsp; Xóa
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col>
        <p
          class="mt-3 text-dark"
          style="font-weight: 500"
        >
          Tổng số danh mục: {{ total }}
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import localData from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';

export default {
  name: 'CategoryTable',
  components: {
    VclTable,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    checkViewOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'stt',
          label: 'STT',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '5%',
          },
        },
        {
          key: 'name',
          label: 'Tên',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '40%' },
        },
        {
          key: 'code',
          label: 'Mã',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '40%' },
        },
        {
          key: 'type',
          label: 'Loại',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { width: '10%' },
          class: 'text-center',
        },
        { key: 'actions', label: '' },
      ],
    };
  },
  methods: {
    checkPermission(permission) {
      return localData.checkPermission(permission);
    },
    canDelete(item) {
      if ([1, 2].includes(item.id)) {
        return false;
      }
      return this.checkPermission('TRANSACTION_CATE_DELETE');
    },
  },
};
</script>

<style lang="scss" scoped>
.ml-10 {
  margin-left: 5px;
}
.ml-20 {
  margin-left: 10px;
}
.ml-30 {
  margin-left: 15px;
}
.ml-40 {
  margin-left: 20px;
}
.ml-50 {
  margin-left: 25px;
}
</style> 
